import CurrencyValueUIModel from './currency-value';
import CurrencyPerLegUIModel from './currency-per-leg';
import currencyPerSegmentUIModel from './currency-per-segments';

class AncillaryUIModel {
  constructor(ancillary = {}) {
    // from api
    this.baggageWeightCollection = ancillary.baggageWeightCollection;
    this.bookingIndicator = ancillary.bookingIndicator;
    this.bookingSource = ancillary.bookingSource;
    this.commercialName = ancillary.commercialName;
    this.commisionIndicator = ancillary.commisionIndicator;
    this.currency = ancillary.currency ? new CurrencyValueUIModel(ancillary.currency) : ancillary.currency;
    this.currencyPerLegArray = ancillary.currencyPerLegArray && ancillary.currencyPerLegArray.length > 0 ?
      ancillary.currencyPerLegArray.map((currencyPerLeg) => {
        return new CurrencyPerLegUIModel(currencyPerLeg);
      }) : [];
    this.currencyPerSegmentArray = ancillary.currencyPerSegmentArray && ancillary.currencyPerSegmentArray.length > 0 ?
      ancillary.currencyPerSegmentArray.map(currencyPerSegment => {
        return new currencyPerSegmentUIModel(currencyPerSegment);
      }) : [];
    this.currencyEquivalent = ancillary.currencyEquivalent;
    this.discountPrice = ancillary.discountPrice;
    this.emdConsummedAtIssuance = ancillary.emdConsummedAtIssuance;
    this.emdType =  ancillary.emdType;
    this.equipmentType =  ancillary.equipmentType;
    this.fareGuaranteedIndicator = ancillary.fareGuaranteedIndicator;
    this.farelogixDesignator = ancillary.farelogixDesignator;
    this.farelogixPrice = ancillary.farelogixPrice;
    this.feeApplicationIndicator = ancillary.feeApplicationIndicator;
    this.groupCode = ancillary.groupCode;
    this.interlineIndicator = ancillary.interlineIndicator;
    this.isChubbPrice = ancillary.isChubbPrice;
    this.legsCorporate = ancillary.legsCorporate;
    this.offerCode = ancillary.offerCode;
    this.order = ancillary.order;
    this.originalTotalCost = ancillary.originalTotalCost;
    this.owningCarrierCode = ancillary.owningCarrierCode;
    this.perUnit = ancillary.perUnit;
    this.points = null;
    if (typeof ancillary.points !== 'undefined') {
      this.points = ancillary.points;
    }
    this.priceCalcList = ancillary.priceCalcList;
    this.purchaseIdCP = ancillary.purchaseIdCP;
    this.realRficSubcode = ancillary.realRficSubcode;
    this.redeemed = ancillary.redeemed;
    this.redeemedCorporate = ancillary.redeemedCorporate;
    this.redeemedCP = ancillary.redeemedCP;
    this.refundFormIndicator = ancillary.refundFormIndicator;
    this.refundIndicator = ancillary.refundIndicator;
    this.rficCode = ancillary.rficCode;
    this.rficSubcode = ancillary.rficSubcode;
    this.segmentIndicator = ancillary.segmentIndicator;
    this.ssrCode = ancillary.ssrCode;
    this.taxExemption = ancillary.taxExemption;
    this.ticketingIndicator = ancillary.ticketingIndicator;
    this.ticketUsedForEMDPricing = ancillary.ticketUsedForEMDPricing;
    this.type = ancillary.type;
    this.unitIdCP = ancillary.unitIdCP;
    this.validateStateChubb = ancillary.validateStateChubb;
    this.vendor = ancillary.vendor;
  }

  getTotalPerLeg(legCode) {
    const totalPerLeg = this.currencyPerLegArray.find(currency => {
      return currency.legCode === legCode;
    });

    return totalPerLeg && totalPerLeg !== undefined ? totalPerLeg.currency.getTotal() : null;
  }

  getTotalTaxPerLeg(legCode) {
    const totalTaxPerLeg = this.currencyPerLegArray.find(currency => {
      return currency.legCode === legCode;
    });

    return totalTaxPerLeg && totalTaxPerLeg !== undefined ? totalTaxPerLeg.currency.getTotalTax() : null;
  }

  getTaxDetailsPerLeg(legCode) {
    const taxDetailsPerLeg = this.currencyPerLegArray.find(currency => {
      return currency.legCode === legCode;
    });

    return taxDetailsPerLeg && taxDetailsPerLeg !== undefined ? taxDetailsPerLeg.currency.getTaxDetails() : null;
  }

  getTotal() {
    return this.currency.getTotal();
  }

  getTotalPoints() {
    return this.currency.getTotalPoints();
  }

  getTotalPerLeg(legCode) {
    if (this.hasBagCorporateByLegCode(legCode)) {
      return 0;
    } else {
      const currencyPerLeg = this.getCurrencyByLeg(legCode);
      return currencyPerLeg ? currencyPerLeg.getTotal() : this.currency.getTotal();
    }
  }

  getTotalCPPointsPerLeg(legCode) {
    const currencyPerLeg = this.getCurrencyByLeg(legCode);
    return currencyPerLeg ? currencyPerLeg.getTotalPoints() : this.currency.getTotalPoints();
  }

  getTotalTax() {
    return this.currency.getTotalTax();
  }

  getTaxDetails() {
    return this.currency.getTaxDetails();
  }

  getCurrencyByLeg(legCode) {
    const currencyPerLeg = this.currencyPerLegArray.find(currency => {
      return currency.legCode === legCode;
    });
    return currencyPerLeg ? currencyPerLeg.currency : null;
  }

  getWeight(unit) {
    let weight = null;

    if (this.baggageWeightCollection) {
      const baggageWeight = this.baggageWeightCollection[unit === 'Kg' ? 0 : 1];
      weight = `${ baggageWeight?.baggageMaxWeight } ${ baggageWeight?.baggageWeightUnit }`;
    }

    return weight;
  }

  hasBagCorporateByLegCode(legCode) {
    return this.legsCorporate && this.legsCorporate.includes(legCode);
  }

  setRedeemedCorporate(legCode) {
    this.redeemedCorporate = this.hasBagCorporateByLegCode(legCode);
  }

  toApi() {
    const currencyPerLeg = this.currencyPerLegArray.map(currency => {
      return currency.toAPI();
    });

    const currencyPerSegment = this.currencyPerSegmentArray.map(currency => {
      return currency.toAPI();
    });

    return {
      '_meta':{
        'class': 'Ancillary',
      },
      'baggageWeightCollection': this.baggageWeightCollection,
      'bookingIndicator': this.bookingIndicator,
      'bookingSource': this.bookingSource,
      'commercialName': this.commercialName,
      'commisionIndicator': this.commisionIndicator,
      'currency': this.currency ? this.currency.toAPI() : this.currency,
      'currencyEquivalent': this.currencyEquivalent,
      'currencyPerLegArray': currencyPerLeg ? currencyPerLeg : [],
      'currencyPerSegmentArray': currencyPerSegment ? currencyPerSegment : [],
      'discountPrice': this.discountPrice,
      'emdConsummedAtIssuance': this.emdConsummedAtIssuance,
      'emdType': this.emdType,
      'equipmentType': this.equipmentType,
      'fareGuaranteedIndicator': this.fareGuaranteedIndicator,
      'farelogixDesignator': this.farelogixDesignator,
      'farelogixPrice': this.farelogixPrice,
      'feeApplicationIndicator': this.feeApplicationIndicator,
      'groupCode': this.groupCode,
      'interlineIndicator': this.interlineIndicator,
      'isChubbPrice': this.isChubbPrice,
      'legsCorporate': this.legsCorporate,
      'offerCode': this.offerCode,
      'order': this.order,
      'originalTotalCost': this.originalTotalCost,
      'owningCarrierCode': this.owningCarrierCode,
      'perUnit': this.perUnit,
      'points': this.points,
      'priceCalcList': this.priceCalcList,
      'purchaseIdCP': this.purchaseIdCP,
      'realRficSubcode': this.realRficSubcode,
      'redeemed': this.redeemed,
      'redeemedCorporate': this.redeemedCorporate,
      'redeemedCP': this.redeemedCP,
      'refundFormIndicator': this.refundFormIndicator,
      'refundIndicator': this.refundIndicator,
      'rficCode': this.rficCode,
      'rficSubcode': this.rficSubcode,
      'segmentIndicator': this.segmentIndicator,
      'ssrCode': this.ssrCode,
      'taxExemption': this.taxExemption,
      'ticketingIndicator': this.ticketingIndicator,
      'ticketUsedForEMDPricing': this.ticketUsedForEMDPricing,
      'type': this.type,
      'unitIdCP': this.unitIdCP,
      'validateStateChubb': this.validateStateChubb,
      'vendor': this.vendor,
    };
  }

  toApiTravelerAncillary(legCode, quantity = 1) {
    return {
      '_meta':{
        'class': 'TravelerAncillary',
      },
      'ancillary': this.toApi(),
      'quantity': quantity,
      'options': [],
      'legCode': legCode,
    };
  }
}

export default AncillaryUIModel;
